import React, { ReactNode } from 'react';
import { TabContextProvider } from './TabContext';

interface TabContainerProps {
  children: ReactNode;
  defaultActiveKey: string;
  onTabChange?: (key: string) => void;
}

const TabContainer: React.FC<TabContainerProps> = ({ children, defaultActiveKey, onTabChange }: TabContainerProps) => {
  return (
    <TabContextProvider defaultActiveKey={defaultActiveKey} onTabChange={onTabChange}>
      {children}
    </TabContextProvider>
  );
};

export { TabContainer };
